import { Modal } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import { ControllerObtenerProcedimientosPendientes } from "../../Service/Service.porcedimientos";
import { useDispatch, useSelector } from "react-redux";
import { agregarProcedimientos } from "../../redux/actions";
import { ProcedimientosDeleteBilling } from "../../Service/Service.billing";
import Swal from "sweetalert2";
import { tituloClinico } from "../../utils/textoClinico";
import ListaPendientes from "./Crear/ListaPendientes";
import "../../styles/FacturaCrear.css";

export default function ProcedimientosPendienteFactura({data}) {

    const { show, handleClose, pacienteSeleccionado, seguroSeleccionado } = data;
    const [procedimientosList, setprocedimientosList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedProcedimientos, setSelectedProcedimientos] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredProcedimientos, setFilteredProcedimientos] = useState([]);

    const procedimientos = useSelector((state) => state.facturaredux.procedimientos);

    const dispatch = useDispatch();


    const onRowSelectionChange = (selectedKeys, selectedRows) => {
        setSelectedRowKeys(selectedKeys);
        setSelectedProcedimientos(selectedRows);
    };
    
    const handleAgregarProcedimientos = () => {

        if (selectedProcedimientos.length > 0) {

            const nuevosProcedimientos = selectedProcedimientos.filter(p => 
                !procedimientos.some(proc => proc.idprocedimiento_cita_paciente === p.idprocedimiento_cita_paciente)
            );

            if (nuevosProcedimientos.length > 0) {
                dispatch(agregarProcedimientos(nuevosProcedimientos));
            }

            handleClose();
        }
    };

    const handleDeleteProcedimiento = async(data) => {
        setLoading(true);
        try {

            const response = await ProcedimientosDeleteBilling(data.idprocedimiento_cita_paciente);
            if (!response.success) {
                throw new Error(response.message || "Error al eliminar procedimientos");
            }
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                timer: 1500,
                showConfirmButton: false,
            });
            
        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al eliminar el procedimiento",
            });

        } finally {
            setLoading(false);
            fetchInitialData();
        }
    }
    
    const rowSelection = {
        selectedRowKeys,
        onChange: onRowSelectionChange,
    };

    // FUGA-01: `fetchInitialData` dependia de `procedimientos` (el array de
    // redux con las lineas de la factura). Como el efecto de abajo depende de
    // esta funcion, CADA cambio en las lineas -- agregar una, cambiar una
    // cantidad -- volvia a pedir el listado entero al servidor. Con el paciente
    // real de 526 pendientes eso son 1.536 KB por cada clic.
    //
    // La causa era mezclar dos cosas en un mismo efecto: TRAER los pendientes
    // (depende del paciente) y MARCAR los que ya estan en la factura (depende
    // de la factura). Ahora son dos efectos, y solo el primero va al servidor.
    // La consulta, sus parametros y su respuesta no cambian.
    const fetchInitialData = useCallback(async () => {
        setprocedimientosList(null);
        if (pacienteSeleccionado || seguroSeleccionado) {
            setLoading(true);
            const result = await ControllerObtenerProcedimientosPendientes(pacienteSeleccionado?.value, seguroSeleccionado?.value);
            if (result && result.success) {
                const fetchedProcedimientos = result.data.map((item, index) => ({
                    ...item,
                    key: item.idprocedimiento_cita_paciente,
                    index
                }))

                setprocedimientosList(fetchedProcedimientos);
                setFilteredProcedimientos(fetchedProcedimientos);
            }

            setLoading(false);
        }

    }, [pacienteSeleccionado, seguroSeleccionado]);

    useEffect(() => {
        if (show) {
            fetchInitialData();
        }
    }, [show, fetchInitialData]);

    // Sincronizar que salga marcado lo que YA esta en la factura. Es lo mismo
    // que hacia el bloque de arriba, con el mismo criterio
    // (idprocedimiento_cita_paciente), pero sin arrastrar una peticion detras.
    useEffect(() => {
        if (!show || !procedimientosList) return;
        const enLaFactura = new Set(procedimientos.map(p => p.idprocedimiento_cita_paciente));
        const seleccionados = procedimientosList.filter(p => enLaFactura.has(p.idprocedimiento_cita_paciente));
        setSelectedProcedimientos(seleccionados);
        setSelectedRowKeys(seleccionados.map(p => p.key));
    }, [show, procedimientosList, procedimientos]); 
    
    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredProcedimientos(procedimientosList);
        } else {
            const filteredData = procedimientosList.filter(item =>
                item.ExamenTipo.codigo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.ExamenTipo.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredProcedimientos(filteredData);
        }
    }, [searchTerm, procedimientosList]);

    // FACTURA-UI FASE 5: cambia SOLO la presentacion. La carga, el filtro, la
    // seleccion, `handleAgregarProcedimientos` y `handleDeleteProcedimiento`
    // quedan exactamente como estaban.
    const lista = filteredProcedimientos || [];
    const totalPendientes = (procedimientosList || []).length;

    const alternarTodos = () => {
        const visiblesMarcadas = lista.filter((p) => selectedRowKeys.includes(p.key));
        if (lista.length > 0 && visiblesMarcadas.length === lista.length) {
            const quedan = selectedProcedimientos.filter((p) => !lista.some((v) => v.key === p.key));
            onRowSelectionChange(quedan.map((p) => p.key), quedan);
        } else {
            const union = [...selectedProcedimientos];
            lista.forEach((p) => {
                if (!union.some((u) => u.key === p.key)) union.push(p);
            });
            onRowSelectionChange(union.map((p) => p.key), union);
        }
    };

    const alternarUno = (fila) => {
        const siguiente = selectedRowKeys.includes(fila.key)
            ? selectedProcedimientos.filter((p) => p.key !== fila.key)
            : [...selectedProcedimientos, fila];
        onRowSelectionChange(siguiente.map((p) => p.key), siguiente);
    };

    // Lo que se va a llevar, con el mismo criterio que la factura:
    // cantidad x precio. Ninguna formula nueva.
    const importeSeleccionado = selectedProcedimientos.reduce((acc, p) => {
        const precio = Number(p?.precio);
        const cantidad = Number(p?.cantidad) || 1;
        return acc + (Number.isFinite(precio) ? precio * cantidad : 0);
    }, 0);

    const titular = pacienteSeleccionado
        ? pacienteSeleccionado.label
        : seguroSeleccionado
        ? seguroSeleccionado.label
        : "";

    const n = selectedProcedimientos.length;

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="fpend__titulo">
                    Procedimientos pendientes
                    <span className="fpend__titular">{tituloClinico(titular)}</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="fpend__cuerpo">
                <ListaPendientes
                    lista={lista}
                    total={totalPendientes}
                    loading={loading}
                    searchTerm={searchTerm}
                    onSearch={setSearchTerm}
                    seleccionadas={selectedRowKeys}
                    onAlternarTodos={alternarTodos}
                    onAlternarUno={alternarUno}
                    onEliminar={handleDeleteProcedimiento}
                />
            </Modal.Body>

            <Modal.Footer className="fpend__pie">
                <span className="fpend__resumen">
                    {n === 0
                        ? "Ninguno seleccionado"
                        : `${n} seleccionado${n === 1 ? "" : "s"} · $${importeSeleccionado.toFixed(2)}`}
                </span>
                <button type="button" className="fcrear__btn" onClick={handleClose}>
                    Cancelar
                </button>
                <button
                    type="button"
                    className="fcrear__btn fcrear__btn--primario"
                    onClick={handleAgregarProcedimientos}
                    disabled={n === 0}
                >
                    {n === 0 ? "Agregar a la factura" : `Agregar ${n} a la factura`}
                </button>
            </Modal.Footer>
        </Modal>
    )
}
